import React from 'react';
import './App.css';
import NJADVRIForm from './components/NJADVRIForm';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <main className="App-main">
          <NJADVRIForm />
        </main>
      </div>
    </LanguageProvider>
  );
}

export default App;
